'use client';
import * as motion from 'framer-motion/client';
import styles from './change.module.scss';
import Image from 'next/image';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import T from '../../../common/components/T';
import classNames from 'classnames';

const ChangePage = () => {
    const ref = useRef(null);
    const isInView = useInView(ref);

    return (
        <div ref={ref} className={styles.changeWrapperSection}>
            <motion.div className={styles.changeWrapper} initial={'hidden'} whileInView={'visible'}>
                <motion.div
                    className={styles.iconWrapper}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{
                        duration: 0.25,
                        ease: 'linear'
                    }}
                    style={{ transformOrigin: 'center' }}
                    //viewport={{ once: true }}
                >
                    <Image
                        width={698}
                        height={698}
                        className={styles.iconWrapperLogo}
                        src={'/src/landing/description/icon.svg'}
                        alt='bg icon'
                    />
                    <motion.div
                        className={classNames(styles.iconWrapperLogoBorder, styles.iconWrapperLogoBorder_01)}
                        initial={{ scale: 0, opacity: 0 }}
                        whileInView={{ scale: 1, opacity: 1 }}
                        transition={{
                            duration: 0.25,
                            ease: 'linear'
                        }}
                    />
                    <motion.div
                        className={classNames(styles.iconWrapperLogoBorder, styles.iconWrapperLogoBorder_02)}
                        initial={{ scale: 0, opacity: 0 }}
                        whileInView={{ scale: 1, opacity: 1 }}
                        transition={{
                            duration: 0.25,
                            ease: 'linear'
                        }}
                    />
                </motion.div>
                <div className={styles.changeTextWrapper}>
                    <motion.h2
                        className={styles.changeText}
                        style={{
                            transition: 'transform 0.4s linear',
                            y: !isInView ? '150%' : 0
                        }}
                    >
                        <T textName={'landing-changepage-new1'} defaultStr={'Вместе'} page='/' />
                    </motion.h2>
                </div>
                <div className={styles.changeTextWrapper}>
                    <motion.h2
                        className={styles.changeText}
                        style={{
                            transition: 'transform 0.4s linear',
                            y: !isInView ? '150%' : 0
                        }}
                    >
                        <T textName={'landing-changepage-new2'} defaultStr={'изменим мир'} page='/' />
                    </motion.h2>
                </div>
                <div className={styles.changeTextWrapper}>
                    <motion.h2
                        className={styles.changeText}
                        style={{
                            transition: 'transform 0.4s linear',
                            y: !isInView ? '150%' : 0
                        }}
                    >
                        <T textName={'landing-changepage-new3'} defaultStr={'к лучшему!'} page='/' />
                    </motion.h2>
                </div>
                <motion.div
                    className={styles.ellips1Wrapper}
                    style={{
                        transition: 'transform 0.5s linear',
                        y: !isInView ? '-140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon3' width={220} height={220} />
                </motion.div>
                <motion.div
                    className={styles.ellips2Wrapper}
                    style={{
                        transition: 'transform 0.5s linear',
                        x: !isInView ? '100%' : 0
                    }}
                >
                    <motion.div>
                        <Image src={'ellipse.svg'} alt='ellipse icon4' width={268} height={268} />
                    </motion.div>
                </motion.div>
                <motion.div
                    className={styles.ellips3Wrapper}
                    style={{
                        transition: 'transform 0.5s linear',
                        y: !isInView ? '140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon3' width={220} height={220} />
                </motion.div>
                <motion.div
                    className={styles.ellips6Wrapper}
                    style={{
                        transition: 'transform 0.5s linear',
                        y: !isInView ? '140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon3' width={220} height={220} />
                </motion.div>
            </motion.div>

            <div className={styles.changeDecorWrapper}>
                <motion.div
                    className={styles.ellips4Wrapper}
                    style={{
                        transition: 'transform 0.5s linear',
                        y: !isInView ? '150%' : 0,
                        x: !isInView ? '30%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon5' width={377} height={377} />
                </motion.div>
                <motion.div
                    className={styles.ellips5Wrapper}
                    style={{
                        transition: 'transform 0.5s linear',
                        y: !isInView ? '140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon3' width={220} height={220} />
                </motion.div>
            </div>
        </div>
    );
};
export default ChangePage;
